import { render, staticRenderFns } from "./isFixedHeader.vue?vue&type=template&id=e453711e&scoped=true&"
import script from "./isFixedHeader.vue?vue&type=script&lang=js&"
export * from "./isFixedHeader.vue?vue&type=script&lang=js&"
import style0 from "./isFixedHeader.vue?vue&type=style&index=0&id=e453711e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e453711e",
  null
  
)

export default component.exports